import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const patchPhaseItem = (params) =>
  HttpClient().patch(`/phase_items/v2/${params.data.id}`, params)

const updatePhaseItem = (params, callback, view) => (dispatch) =>
  patchPhaseItem(params)
    .then((response) => {
      if (response.status === 200 && callback) callback()
      return dispatch(loadJsonApiEntities({ ...response.data, view }))
    })
    .catch((err) => {
      console.info(err)
      throw err
    })

export default updatePhaseItem
